module.exports = __webpack_public_path__ + "img/wizard1.5693d6cc.png";